<template>
	<div>

		<div class="references">
			<!-- <div class="bandeau-title">NOS <b>Références</b></div> -->

			<div class="logos_ref content">
			<!-- <div class="bandeau-title">NOS Références</div> -->

				<img v-for="img in imgs" :src="'/references/' + img" alt="">

			</div>
		</div>

	</div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'References',
  data () {
	return {
      imgs: ['1.jpg', '2.jpg', '3.jpg', '4.jpg', '5.jpg', '6.jpg', '7.jpg', '8.jpg', '8-b.jpg', '9.jpg', '10.jpg', '11.jpg', '12.jpg', '13.jpg', '14.jpg', '15.jpg', '16.jpg', '17.jpg', '18.jpg', '19.jpg'],
	}
  },
  methods: {
  }
}
</script>

<style scoped>
.references {
	background: #fff;
	padding: 10px 0;
	text-align: center;
}
.bandeau-title {
	/*background: #000;*/
	text-align: center;
	text-transform: uppercase;
	padding: 20px 10px;
	/*color: #fff;*/
	color: #000;
	font-size: 2.3em;
}
.logos_ref img { 
	display: inline-block;
	margin: 8px;
	width: 8%;
 }
 
.content {
	width: 100%;
	max-width: 1170px;
	margin: auto;
	text-align: center;
}

@media screen and (max-width: 640px) { 
	.bandeau-title {
		font-size: 1.8em;
	}
	.logos_ref img{ 
		display: inline-block;
		width: 19%;
		margin: 8px;
	 }
}

</style>



// WEBPACK FOOTER //
// src/components/References.vue